var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 21,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.239 1.15L.582 6.946c-.73.75-.73 1.94 0 2.69a1.8 1.8 0 002.615 0l2.494-2.565v11.429c0 1.042.832 1.897 1.845 1.897 1.014 0 1.846-.855 1.846-1.897V7.072l2.494 2.544a1.8 1.8 0 002.615 0c.365-.375.548-.855.548-1.334 0-.48-.183-.98-.548-1.335L8.854 1.149C8.51.795 8.044.586 7.557.586s-.973.209-1.318.563z",
    fill: "#000"
  })));
}
export default SvgArrowTop;